<script setup>
import EyeIcon from '@iconify-vue/ph/eye';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import DataTableLayout from '@js/components/tables/DataTableLayout.vue';
import BaseCell from '@js/components/tables/cells/BaseCell.vue';
import HeaderCell from '@js/components/tables/cells/HeaderCell.vue';
import LinkCell from '@js/components/tables/cells/LinkCell.vue';
import NumberCell from '@js/components/tables/cells/NumberCell.vue';
import TextCell from '@js/components/tables/cells/TextCell.vue';
import { useDataTable } from '@js/utils/dataTable';
import { formatDate } from '@js/utils/formatter';
import { useRoute } from '@js/utils/route';
import { createColumnHelper } from '@tanstack/vue-table';
import { h } from 'vue';

const { route } = useRoute();

const columnHelper = createColumnHelper();

const {
    loading,
    table,
    count,
    globalFilter,
    filters,
    availableFilters,
    setGlobalFilter,
    setFilters,
} = useDataTable({
    columns: [
        columnHelper.accessor(() => null, {
            id: 'name',
            header: () => 'Nom',
            cell: (props) =>
                h(LinkCell, {
                    text: props.row.original.name,
                    href: route(
                        'front.projectManagement.sem.shortMessageServices',
                        {
                            tenant: props.row.original.id,
                        },
                    ),
                    inertia: true,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'total',
            header: () => 'Total',
            cell: (props) =>
                h(NumberCell, {
                    number: props.row.original.total,
                }),
            enableSorting: false,
        }),
        columnHelper.accessor(() => null, {
            id: 'lastSentAt',
            header: () => 'Date dernier SMS',
            cell: (props) =>
                props.row.original.lastSentAt
                    ? h(TextCell, {
                          text: formatDate(props.row.original.lastSentAt),
                      })
                    : null,
            enableSorting: false,
        }),
        columnHelper.display({
            id: 'actions',
            headerCustom: true,
            header: (props) =>
                h(HeaderCell, {
                    header: props.header,
                    title: 'Actions',
                    width: 0,
                }),
            cell: (props) =>
                h(
                    BaseCell,
                    {},
                    {
                        default: () =>
                            h(ActionButton, {
                                size: 'small',
                                square: true,
                                title: 'Voir',
                                href: route(
                                    'front.projectManagement.sem.shortMessageServices',
                                    {
                                        tenant: props.row.original.id,
                                    },
                                ),
                                icon: EyeIcon,
                            }),
                    },
                ),
        }),
    ],
    url: route('front.projectManagement.sem.postShortMessageServices'),
    columnPinning: {
        right: ['actions'],
    },
});
</script>

<template>
    <DataTableLayout
        :table="table"
        :count="count"
        :global-filter="globalFilter"
        :filters="filters"
        :available-filters="availableFilters"
        :set-filters="setFilters"
        :set-global-filter="setGlobalFilter"
        :loading="loading"
    />
</template>
